module.exports = __webpack_public_path__ + "4d4f69ce.png";